import React from "react";

import styles from "./FormButton.module.css";

interface FormButtonProps {
  type?: "button" | "submit" | "reset";
  children: React.ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  variant?: "primary" | "secondary";
  className?: string;
  onClick?: () => void;
}

const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(" ");

export const FormButton: React.FC<FormButtonProps> = ({
  type = "submit",
  children,
  isLoading = false,
  disabled = false,
  variant = "primary",
  className = "",
  onClick,
}) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      type={type}
      disabled={isDisabled}
      onClick={onClick}
      className={cn(styles.button, styles[variant], className)}
    >
      {isLoading ? (
        <div className={styles.loadingContent}>
          <svg
            className={styles.spinner}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Загрузка...
        </div>
      ) : (
        children
      )}
    </button>
  );
};
